import { render, staticRenderFns } from "./UiCard.vue?vue&type=template&id=8b4cc854&"
import script from "./UiCard.vue?vue&type=script&lang=js&"
export * from "./UiCard.vue?vue&type=script&lang=js&"
import style0 from "./UiCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports